import React from 'react';
import Select from 'react-select';
import { FormFeedback, Input } from 'reactstrap';

function SelectComponent(props) {
  const { handleBlur, touched, errors, values } = props.validation
  const onBlur = e => {
    e.target.name = props.name
    handleBlur(e)
  }
  return (
    <>
      <Select
        {...props}
        isClearable
        value={props.defaultValue}
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        onBlur={onBlur}
      />

      <Input
        name={props.name}
        className="form-control d-none"
        type="text"
        value={values.orderId || ""}
        invalid={
          (touched?.details && errors?.details) ?
            (touched?.details[props.detailIndex]?.orderId && errors?.details[props.detailIndex]?.orderId
              ? true
              : false) : false
        }
      />
      {touched?.details && errors?.details ? (
        <FormFeedback type="invalid">
          {errors?.details[props.detailIndex]?.orderId}
        </FormFeedback>
      ) : null}
    </>
  );
}

export default SelectComponent;